import { Col, Modal, Row } from "antd";
import Button from "../Button";

export function ModalConfirmWaitIntegration({
  action,
  closeFn,
  visible,
}: {
  action: (ok: boolean) => void;
  visible: boolean;
  closeFn: () => void;
}) {
  function handleClick(send: boolean) {
    action(send);
    closeFn();
  }

  return (
    <Modal
      title="Integração em andamento"
      visible={visible}
      onCancel={() => handleClick(false)}
      closable={true}
      footer={
        <Row
          gutter={[16, 16]}
          style={{
            marginBottom: "16px",
            paddingLeft: "18px",
            paddingRight: "18px",
          }}>
          <Col span={12}>
            <Button
              size="large"
              type="primary"
              // style={{ backgroundColor: "#0015a0" }}
              className="full-width"
              onClick={() => {
                handleClick(false);
              }}>
              Não
            </Button>
          </Col>
          <Col span={12}>
            <Button
              size="large"
              type="primary"
              className="full-width"
              onClick={() => {
                handleClick(true);
              }}>
              Sim
            </Button>
          </Col>
        </Row>
      }>
      <Row>
        <Col>Estamos processando um grande número de informações.</Col>
      </Row>
      <Row>
        <Col>
          <p>Deseja receber um e-mail quando a integração for finalizada?</p>
        </Col>
      </Row>
    </Modal>
  );
}